import { Button, Box } from '@chakra-ui/react'
import { useStores } from 'hooks/useStores'
import { observer } from 'mobx-react'
import { useEffect } from 'react'
import { getOidcAuthUrl } from 'API/auth'
import { 
  generateSSOState, 
  storeSSOCallbackData
} from 'utils/sso'

type SSOButtonsProps = {
  backgroundColor?: string
  width?: string
  height?: string
}

const SSOButtons = ({ backgroundColor, width }: SSOButtonsProps) => {
  const { organizationStore } = useStores()
  const { organization, publicSSOConfigs } = organizationStore

  // Get subdomain from current URL
  const [subdomain] = window.location.host.replace(/^(www\.)/, '').split('.')

  // Note: SSO configs are loaded by app

  const handleSSOLogin = (provider: string) => {
    if (!organization?.id) {
      return
    }

    try {
      const autoCreate = organization.ssoUserProvisioningPolicy === 'auto-create'
      const state = generateSSOState(organization.id, autoCreate)
      
      // Store callback data
      storeSSOCallbackData(state, organization.id, provider, autoCreate)
      
      // Get the authorization URL and redirect
      const authUrl = getOidcAuthUrl(provider, state, false, organization.id)
      window.location.href = authUrl
      
    } catch (error) {
      console.error('SSO Login Error:', error)
    }
  }

  const enabledConfigs = publicSSOConfigs.filter(config => config.enabled)

  // Don't show anything if no organization found
  if (!organization?.id) {
    return null
  }

  // Don't show anything if no enabled SSO configs
  if (enabledConfigs.length === 0) {
    return null
  }

  return (
    <Box>
      {enabledConfigs.map(ssoConfig => (
        <Button 
          key={ssoConfig.provider} 
          onClick={() => handleSSOLogin(ssoConfig.provider)}
          width={width || '100%'}
          height="48px"
          variant="outline"
          color={'white'}
          backgroundColor={backgroundColor || '#2A3E60'}
          border={'none'}
          _hover={{ opacity: 0.8 }}
          _active={{ opacity: 0.8 }}
        >
          Continue with Organization SSO
        </Button>
      ))}
    </Box>
  )
}

export default observer(SSOButtons)